var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "social-media",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.06,
    height: 23.06,
    viewBox: "0 0 23.06 23.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M25.059,20.83a4.232,4.232,0,1,0,4.234,4.229A4.232,4.232,0,0,0,25.059,20.83Z",
    transform: "translate(-13.529 -13.529)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M22.913,5H10.147A5.155,5.155,0,0,0,5,10.147V22.913a5.152,5.152,0,0,0,5.147,5.147H22.913a5.149,5.149,0,0,0,5.147-5.147V10.147A5.152,5.152,0,0,0,22.913,5ZM16.53,24A7.469,7.469,0,1,1,24,16.53,7.482,7.482,0,0,1,16.53,24Zm7.628-13.583A1.58,1.58,0,1,1,25.74,8.842,1.581,1.581,0,0,1,24.159,10.419Z",
    transform: "translate(-5 -5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.6435d8246c3975d11bc756e346c48e61.svg";
export { ForwardRef as ReactComponent };